import Skeleton from './Skeleton';

const SummaryCard = ({ label, value, sub, color, loading, children, onClick }) => {
  const clickable = typeof onClick === 'function';
  const handleKeyDown = (e) => {
    if (!clickable) return;
    if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault();
      onClick();
    }
  };
  return (
    <div
      className={`fd-card ${color}`}
      onClick={clickable ? onClick : undefined}
      role={clickable ? 'button' : undefined}
      tabIndex={clickable ? 0 : undefined}
      onKeyDown={handleKeyDown}
      style={clickable ? { cursor: 'pointer' } : undefined}
    >
      <div className="fd-card-label">{label}</div>
      {loading ? (
        <>
          <Skeleton width={130} height={26} style={{ marginBottom: 8 }} />
          <Skeleton width={100} height={11} />
        </>
      ) : (
        <>
          <div className="fd-card-value">{value}</div>
          {children || <div className="fd-card-sub">{sub}</div>}
        </>
      )}
    </div>
  );
};

export default SummaryCard;
